import { render, staticRenderFns } from "./copypressure.vue?vue&type=template&id=7816367d&"
import script from "./copypressure.vue?vue&type=script&lang=ts&"
export * from "./copypressure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "copypressure.vue"
export default component.exports